/**
 * Componente de Ruta Protegida
 * Verifica autenticación antes de permitir acceso a rutas protegidas
 */

import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      try {
        // Verificar si hay token y datos de usuario en localStorage
        const token = localStorage.getItem('token');
        const usuario = localStorage.getItem('usuario');
        const isAuthFlag = localStorage.getItem('isAuthenticated');
        
        // Considerar autenticado si hay token Y datos de usuario
        const authenticated = !!(token && usuario);
        
        console.log('🔐 [PROTECTED-ROUTE] Verificando autenticación:', {
          hasToken: !!token,
          hasUser: !!usuario,
          isAuthFlag,
          authenticated
        });

        setIsAuthenticated(authenticated);
        
        // Si está autenticado, marcar la bandera
        if (authenticated) {
          localStorage.setItem('isAuthenticated', 'true');
        } else {
          localStorage.removeItem('isAuthenticated');
        }
        
      } catch (error) {
        console.error('🔐 [PROTECTED-ROUTE] Error verificando autenticación:', error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Mientras está cargando, mostrar indicador
  if (loading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Verificando autenticación...</p>
        </div>
        <style jsx>{`
          .auth-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            background-color: #f8f9fa;
          }
          .loading-spinner {
            text-align: center;
          }
          .spinner {
            border: 4px solid #f3f3f3;
            border-top: 4px solid #007bff;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin 1s linear infinite;
            margin: 0 auto 16px;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    console.log('🔐 [PROTECTED-ROUTE] Usuario no autenticado, redirigiendo al login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar si requiere cambio de contraseña obligatorio
  const requiresPasswordChange = localStorage.getItem('requiresPasswordChange');
  const currentPath = location.pathname;
  
  // Si requiere cambio de contraseña y no está ya en esa página, redirigir
  if (requiresPasswordChange === 'true' && !currentPath.includes('/first-password-change')) {
    console.log('🔐 [PROTECTED-ROUTE] Usuario requiere cambio de contraseña, redirigiendo...');
    return <Navigate to="/first-password-change" replace />;
  }

  // Si está autenticado, renderizar el componente hijo
  return children;
};

export default ProtectedRoute; 